/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface SourceOption
 */
export interface SourceOption {
    /**
     *
     * @type {string}
     * @memberof SourceOption
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof SourceOption
     */
    name: string;
}

/**
 * Check if a given object implements the SourceOption interface.
 */
export function instanceOfSourceOption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function SourceOptionFromJSON(json: any): SourceOption {
    return SourceOptionFromJSONTyped(json, false);
}

export function SourceOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'name': json['name'],
    };
}

export function SourceOptionToJSON(value?: SourceOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'name': value.name,
    };
}
